/// <amd-module name="WidgetCommon/IterationDatesMessage/SetIterationDatesMessage" />
import * as React from "react";
import { Size, VisualMessageAction, VisualMessageBase } from "Reporting/Visuals/VisualMessages/VisualMessageBase";
import { getProject } from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";
import { VssComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import * as Resources from "WidgetCommon/IterationDatesMessage/Resources";

export interface SetIterationDatesProps {
    visualTitle: string;
    size: Size;
    actionOptions: VisualMessageAction;
}

/** Used for Rendering "No Data" Experiences for Charting-centric visuals. */
export class SetIterationDatesMessage extends VssComponent<SetIterationDatesProps, {}> {
    public render(): JSX.Element {
        return (
            <VisualMessageBase
                visualTitle={this.props.visualTitle}
                messageContent={Resources.SetIterationDates_Message}
                action={this.props.actionOptions}
                size={this.props.size}
                imagePath={`ms.vss-reporting/reporting-visuals-common/images/sprintBurndown-buildChartLoading.png`}
                altText={Resources.SetIterationDates_AltText}
            />
        );
    }
}

export function getSetIterationsMessage(context: IVssPageContext, title: string, size: Size): JSX.Element {
    const setIterationsLink = routeUrl(context, "ms.vss-admin-web.project-admin-hub-route", {
        project: getProject(context).name,
        adminPivot: "work"
    });
    return (
        <SetIterationDatesMessage
            visualTitle={title}
            size={size}
            actionOptions={{
                text: Resources.SetupIterationsLink,
                ariaLabel: Resources.SetupIterationsLink,
                href: setIterationsLink
            }}
        />
    );
}
